export const CLICK_SHIELD_TARGET = "data-click-shield-target";
